import { Alert, Box, CircularProgress } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { Navigate } from 'react-router-dom';

import { hasPermission } from '@/api/admin-access';
import { defaultAdminPathForPermissions } from '@/config/permissions';
import { UserStore } from '@/stores';

const PermissionLanding = () => {
  const authenticated = UserStore.useState((state) => state.authenticated);
  const access = UserStore.useState((state) => state.access);
  const loading = UserStore.useState((state) => state.loadingAccess);

  if (!authenticated) return <Navigate to="/login" replace />;
  if (loading) {
    return (
      <Box py={8} textAlign="center">
        <CircularProgress size={28} />
      </Box>
    );
  }

  let destination = defaultAdminPathForPermissions((key) =>
    hasPermission(access, key, 'read')
  );
  if (isMobile && destination === '/cigars/manager') {
    destination = '/cigars/matches';
  }
  if (destination) return <Navigate to={destination} replace />;

  return (
    <Alert severity="error" sx={{ maxWidth: 800, margin: '30px auto' }}>
      Your account does not have access to an admin section. Ask a superadmin to
      assign a role.
    </Alert>
  );
};

export default PermissionLanding;
